import React, { Component } from 'react';
import Label from '../../../components/atoms/Label';
import LabelWithText from '../../../components/molecules/LabelWithText';
import Button from '../../../components/atoms/Button';
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo';
const profilePic = '/img/icon/profil-icon-user.png'


export default ({ data }) => {
  const statusUser = () => {
    let statusCorporate = data.customerInfo.corporate.status
    // console.log({data : data.status, statusCorporate});
    
    if(data.status === 'VER'){
      if(statusCorporate === 'VER'){
        return { status : "Verified", color : 'green' }
      } else if( statusCorporate === 'DFT' || statusCorporate === 'SBM' || statusCorporate === 'RNW' ){
        return { status : "Pending", color : 'yellow' }
      } else if(statusCorporate === 'SPD'){
        return { status : "Suspended", color : 'red' }
      } else if(statusCorporate === 'RJT'){
        return { status : "Rejected", color : 'red' }
      } else{
        return { status : "-", color : 'green' }
      }
    } else if( data.status === 'DFT' || data.status === 'SBM' || data.status === 'RNW' ){
      return { status : "Pending", color : 'yellow' }
    } else if(data.status === 'SPD'){
      return { status : "Suspended", color : 'red' }
    } else if(data.status === 'RJT'){
      return { status : "Rejected", color : 'red' }
    } else{
      return { status : "-", color : 'green' }
    }
  }
  let { fullName } = data.picDetail
  return(
    <div className='card-informasi-pinjaman'>
      <div className='container-top'>
        <img className='profil-picture' src={profilePic} />
        <p className='initial-display'>{data.customerInfo ? data.customerInfo.corporate.nickname : "-"}</p>
        <Label value='Status: ' className='fontsize-status' />
        <Label value={ statusUser().status } className={`fontsize-status ${statusUser().color} label-kc-mb`} />
        <p>
          <Label value='Tgl. Bergabung: ' className='fontsize-tgl' />
          <Label value={ data.createdAt ? dateFormatIndo(data.createdAt, "long") : "-" } className='fontsize-tgl label-kc-mb' />
        </p>
      </div>
      <div className='container-bottom'>
        <LabelWithText label = {'Kode Peminjam'} text = {data.borrowerUID ? data.borrowerUID : "-"}/>
        <LabelWithText label = {'No. Telp. Perusahaan'} text = {data.companyPhone ? data.companyPhone : "-"} />
        <LabelWithText label = {'Surel Perusahaan'} text = { data.companyEmail ? data.companyEmail : "-"} />
        <LabelWithText label = {'Nama PIC'} text = { fullName ? fullName : "-"} />
      </div>
    </div>
  )
}